import { FC, useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import { isSourceWeixin, isDouYinEnvironment } from '@/utils/index'
import { Image, DotLoading, Toast } from 'antd-mobile'
import { getDyGame, getThirdAuth, getTokenApi, login, webjs } from '@/api/user'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { douYinLogin } from '@/hooks/douYinLogin'
import { useSelectRole } from '@/hooks/useSelectRole'

export const SelectGame: FC = props => {
  const { t } = useTranslation();
  const [getRoles] = useSelectRole();
  const { initDysdk, showOpenAuth } = douYinLogin()
  const dispatch = useStoreDispatch();
  const { user }: any = useStoreState();
  const { thirdType } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const argument = queryParams.get('argument');
  const [param1, param2] = argument?.split('@') ?? [];

  const [submitting, setSubmitting] = useState(false)
  const [gameList, setGameList] = useState([])
  let appId = null;

  const getToken = async model => {
    if (submitting) return
    setSubmitting(true)
    const res = await getTokenApi(model).finally(() => setSubmitting(false))
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('user-center.login.login-tips')}` });
      localStorage.setItem('token', res.data.token);
      dispatch({ type: actionTypes.SET_USER, payload: { isLogin: true } });
    }
    return res
  }

  const gotoDy = async (v: any) => {
    const { sdk, appId } = v
    const redirectUrl = thirdType === '1' ? window.location.href + '?argument=' + appId + '@' + sdk : window.location.href + '?argument=' + appId + '@' + sdk

    setSubmitting(true)
    if (isDouYinEnvironment && thirdType === '2') {
      const res = await webjs({ thirdType, sdk, appId, source: 'wap', redirectUrl }).finally(() => setSubmitting(false))
      if (res.code === 0) {
        try {
          await initDysdk({
            thirdAppId: res.data.thirdAppId,
            sign: res.data.sign,
            timestamp: res.data.timestamp,
            nonce: res.data.nonce,
            redirectUrl,
          })

          console.log('ready showOpenAuth')

          const dySdkRes = await showOpenAuth({ client_key: res.data.thirdAppId })
          sendLogin({
            source: 'wap',
            type: 5,
            thirdCode: dySdkRes,
            thirdType,
            sdk,
            appId
          })
        } catch (error) {
          Toast.show({ icon: 'fail', content: error });
        }
      } else {
        Toast.show({ icon: 'fail', content: res.msg });
      }
    } else {
      const res = await getThirdAuth({ thirdType, sdk, appId, source: isSourceWeixin() ? 'wap' : 'pc', redirectUrl }).finally(() => setSubmitting(false))
      if (res.code === 0) {
        window.location.href = res.data
        // window.location.href = 'https://open.douyin.com/platform/oauth/connect?client_key=awf4xgy8cibvhzuv&response_type=code&scope=user_info&redirect_uri=https://www.douyin.com'
      }
    }
  }

  const getGame = async () => {
    setSubmitting(true)
    const res = await getDyGame({ thirdType, appId }).finally(() => setSubmitting(false))
    if (res?.code === 0) {
      setGameList(res.data ?? [])
    }
  }

  const getLogin = async () => {
    const params: any = {
      source: isSourceWeixin() ? 'wap' : 'pc',
      type: 5,
      thirdCode: code,
      thirdType,
      sdk: param2,
      appId: param1
    }
    sendLogin(params)
  }
  // 处理登录
  const sendLogin = async (params) => {
    setSubmitting(true)
    const res = await login(params).finally(() => setSubmitting(false))
    if (res.code === 0) {
      res.data.userVos.map(option => {
        option.token = res.data.token
      })
      getToken(res.data.userVos[0])
    }
  }

  // 如果登录成功或者进入登录页时已登录 则跳转到选择角色页
  useEffect(() => {
    user.isLogin && getRoles();
  }, [user.isLogin])

  useEffect(() => {
    if (code && !user.isLogin) {
      getLogin()
    }
  }, [code])

  useEffect(() => {
    let getAppId = localStorage.getItem('csfeAppId')
    if (getAppId) {
      appId = getAppId.split('_')[0]
    }
    getGame()
  }, [])

  return (
    <>
      {submitting ? <div className={css.loadingBox}><DotLoading color={'primary'} /></div> : <div className={css.Page}>
        <div className={css.title}>请选择登陆的{thirdType === '1'?'微信':thirdType === '2'?'抖音':'支付宝'}小游戏</div>
        <div className={css.gameBox}>
          {gameList.length > 0 && gameList.map((v: any, index: any) => <div className={css.games} key={index} onClick={() => gotoDy(v)}>
            <Image className={css.gameImg} src={v.icon} />
            <span className="ell">{v.gameName}</span>
          </div>)}
          {gameList.length === 0 && <div className={css.noGame}>{t('user-center.select-role.no-game')}</div>}
        </div>
      </div>}
    </>
  )
}


